import React from 'react';
import { NavLink } from 'react-router-dom';

import CustomAvatar from '@app/components/UI/CustomAvatar/CustomAvatar';
import { MemorialsRes } from '@app/objects/PetMemorial';

const imagePlaceholder = require('@images/image-placeholder.png');

interface Props {
	item: MemorialsRes,
	index: number;
}

const PetMemorialIcon: React.FC<Props> = ({ item, index }) => {
	const [imgSrc, setImgSrc] = React.useState(item.images[0]);

	React.useEffect(() => {
		setImgSrc(item.images[0]);
	}, []);

	return (
		<NavLink key={index} to={`/pet-memorial/${item.id}`} className="pet-memorial-head__pop-icon">
			<CustomAvatar
				src={imgSrc}
				maxWidth={150}
				maxHeight={150}
				errorAvatar={imagePlaceholder}
				alt="pop-icon"
			/>
		</NavLink>
	);
};

export default PetMemorialIcon;
